export default "__VITE_ASSET__Bhm8fmx8__"